import { Component, Input } from '@angular/core';
import { GuardService } from '@shared/services/guard.service';
import { IDashboardItems, ITile } from '@shared/interfaces';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-home-tiles',
    templateUrl: './home-tiles.component.html',
    styleUrls: ['./home-tiles.component.scss'],
    standalone: false
})
export class HomeTilesComponent {
    @Input() items: IDashboardItems;

    public tiles: ITile[] = [
        {
            name: 'navigation.reports',
            icon: 'file-alt',
            route: '/reports',
            active: true,
            hidden: () => !this.moduleService.isReportModuleActive
        },
        {
            name: 'navigation.summaryReports',
            icon: 'copy',
            route: '/summary-reports',
            active: true,
            hidden: () => !this.moduleService.isSummaryReportModuleActive
        },
        {
            name: this.moduleService.isCascadedReportingActive ? 'navigation.org' : 'navigation.org2',
            icon: 'sitemap',
            route: '/org-charts',
            active: true,
            hidden: () => !this.moduleService.isOrganisationModuleActive
        },
        {
            name: 'navigation.glossary',
            icon: 'book',
            route: '/glossary',
            active: true,
            hidden: () => !this.moduleService.isGlossaryModuleActive || !this.items?.glossary?.length
        },
        {
            name: 'navigation.hyperlinks',
            icon: 'link',
            route: '/links',
            active: true,
            hidden: () => !this.moduleService.isHyperlinksModuleActive || !this.items?.hyperlinks?.length
        },
        {
            name: 'navigation.admin',
            icon: 'user-cog',
            route: '/admin',
            active: true,
            hidden: () => !this.guardService.isAdmin
        }
    ];

    constructor(
        private guardService: GuardService,
        private moduleService: ModuleService
    ) {}
}
